import React, { useContext, useEffect, useRef } from "react";
import styles from "./StoryCard.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import { Link } from 'react-router-dom';
import { useState } from 'react';

const StoryCard = (props) => {
  const { img, type, quote, desc, name, position, color, href, mobileDesc } = props;
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);
  let wrapClass = `${styles.wrap}`;

  const refWrap = useRef(null);
  const refTrigger = useRef(null);
  useEffect(() => {
    const trigger = refTrigger.current;
    const wrap = refWrap.current;
    let options = {
      threshold: 0,
      rootMargin: '0% 0% -10% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          wrap.classList.add(styles.animate);
          observer.unobserve(trigger);
        }
      })
    }, options);
    observer.observe(trigger);
    return () => {
      observer.unobserve(trigger);
    }
  }, []);
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  let icon = <span className={styles.more__icon}>
    <svg width="45" height="9" viewBox="0 0 45 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M44.8536 4.85355C45.0488 4.65829 45.0488 4.34171 44.8536 4.14645L41.6716 0.964466C41.4763 0.769204 41.1597 0.769204 40.9645 0.964466C40.7692 1.15973 40.7692 1.47631 40.9645 1.67157L43.7929 4.5L40.9645 7.32843C40.7692 7.52369 40.7692 7.84027 40.9645 8.03553C41.1597 8.2308 41.4763 8.2308 41.6716 8.03553L44.8536 4.85355ZM0 5H44.5V4H0V5Z" fill="white" />
    </svg>
  </span>;
  let descElement = null;
  if (isMobile) {
    icon = <span className={styles.more__icon_mobile}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="19.5" fill="white" />
      <path d="M16.2964 29.6294L24.4445 19.9998L16.2964 10.3701" stroke="#008359" strokeWidth="1.5" />
    </svg>
    </span>;
    descElement = <div className={styles.desc}>
      {mobileDesc}
    </div>;
  }else{
    descElement = <div className={styles.desc}>
      {desc}
    </div>;
  }
  return (
    <>
      <div className={styles.trigger} ref={refTrigger}>
        <Link to={{pathname: href, search: window.location.search}} className={wrapClass} ref={refWrap}>
          <div className={styles.img}>
            <picture>
              <source media="(min-width: 1921px)" srcSet={`${path}/img/${img}@2x.webp`} />
              <source media="screen and (max-width: 767px)" srcSet={`${path}/img/${img}-mobile.webp, ${path}/img/${img}-mobile@2x.webp 2x`} />
              <img src={`${path}/img/${img}.webp`} srcSet={`${path}/img/${img}@2x.webp 2x`} alt="" />
            </picture>
          </div>
          <div className={styles.story}>
            <div className={styles.type}>{type}</div>
            <div className={styles.quote}><div className={styles.quote__icon}>
              <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00891 29.6959C10.9009 29.6959 13.4029 26.7769 13.4029 22.8849V7.59486C13.4029 3.84186 10.9009 0.644858 7.00891 0.505859C3.39491 0.505859 0.753906 3.70286 0.753906 7.45586V22.7459C0.753906 26.6379 3.25591 29.6959 7.00891 29.6959ZM26.5539 29.6959C30.4459 29.6959 32.9479 26.7769 32.9479 22.8849V7.59486C32.9479 3.84186 30.4459 0.644858 26.5539 0.505859C22.9399 0.505859 20.2989 3.70286 20.2989 7.45586V22.7459C20.2989 26.6379 22.8009 29.6959 26.5539 29.6959Z" fill="white" />
              </svg>
            </div>
              {quote}</div>
            
          {descElement}
            <div className={styles.more}>
              <span className={styles.more__text}>Читать историю</span>
              {icon}
            </div>

          </div>
          <div className={styles.info}>
            <div className={styles.name}>{name}</div>
            <div className={styles.position}>{position}</div>
          </div>
        </Link>
      </div>
    </>
  );

}

export default StoryCard;
